// import React from 'react'

// function StockAlerts() {
//   return (
//     <div>StockAlerts</div>
//   )
// }

// export default StockAlerts

import { 
  Box, InputLeftElement, Flex, Text, Input, Select, Radio, RadioGroup, Stack, Table, Thead, Tbody, Tr, Th, Td, InputGroup 
} from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useState } from "react";

const StockAlerts = () => {
  const [radioValue, setRadioValue] = useState("all");

 // Dummy data for table rows
const requestData = [
  {
    client: "HSBC",
    mainContact: "Joanne Bloggs",
    lowStockItems: "31",
    requests: "10",
    jobs: "7",
    accountmanager: "Me",
  },
  {
    client: "Royal Mail",
    mainContact: "Olive Andrews",
    lowStockItems: "31",
    requests: "10",
    jobs: "7",
    accountmanager: "Me",
  },
  {
    client: "Bupa",
    mainContact: "Scarlet Stafford",
    lowStockItems: "31",
    requests: "10",
    jobs: "7",
    accountmanager: "Me",
  },
  {
    client: "Conservatives",
    mainContact: "Freddy Williamson",
    lowStockItems: "31",
    requests: "10",
    jobs: "7",
    accountmanager: "Me",
  },
];

  return (
    <Box flex="1" pt="40px" px="8">
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text  fontSize="30px" color="#101828">Stock alerts</Text>
        {/* <Button background="#1e98d7" color="#ffffff" _hover="none" fontSize="14px">Create a New Request</Button> */}
      </Flex>

      {/* Filters Section */}
      <Flex gap={4} wrap="wrap" mb={6}>
      <InputGroup flex="1" maxW={{ base: "180px", md: "270px" }}>
          <InputLeftElement pointerEvents="none">
            <LuSearch color="#999999" />
          </InputLeftElement>
          <Input placeholder="Search" fontSize="12px" />
        </InputGroup>
        <Select placeholder="Client (0)" fontSize="12px" color="#667085" width="180px" >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
      </Flex>

      {/* Radio Buttons */}
      <RadioGroup onChange={setRadioValue} value={radioValue} mb={12} color="#475467">
  <Stack direction="row" align="center" color="#475467">
    <Text fontWeight="semibold" fontSize="12px" color="#475467" mr={4}>View:</Text>
    <Radio value="all"  mr={4}>
        <Text fontSize="12px">All clients</Text>
    </Radio>
    <Radio value="approved"  mr={4}>
        <Text fontSize="12px">My clients</Text>
    </Radio>
   
  </Stack>
</RadioGroup>



      {/* Responsive Table */}
      <Box overflowX="auto">
        <Table variant="simple">
          <Thead >
            <Tr >
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Client</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Main Contact</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Low stock items</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Requests</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Jobs</Th>
              <Th pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold">Account manager</Th>
              <Th  pl={0} textTransform="none" color="#475467"  fontSize="12px" fontWeight="semibold"></Th>
            </Tr>
          </Thead>

          <Tbody>
            {requestData.map((request, index) => (
              <Tr key={index} >
                <Td pl={0} py={7} color="#475467" fontSize="12px">{request.client}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.mainContact}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.lowStockItems}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.requests}</Td>
                <Td pl={0}color="#475467" fontSize="12px">{request.jobs}</Td>
                <Td pl={0} color="#475467" fontSize="12px">{request.accountmanager}</Td>
                <Td pl={0} color="#475467" fontSize="12px" textDecoration="underline" cursor="pointer">View</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default StockAlerts;
